import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import path from 'path';

import store from './store';
import history from './history';

import Layout from './components/layout/Layout.jsx';

import './styles/bootstrap-3.3.7.min.css';
import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../node_modules/ag-grid-community/dist/styles/ag-theme-dark.css';
import '../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import '../node_modules/cropperjs/dist/cropper.css';
import '../node_modules/react-date-picker/dist/DatePicker.css';

import styles from './styles/variables.scss';

require('typeface-roboto');

render(
  <Provider store={store}>
    <Router
      basename={path.join(APP_CONFIG.appRoot, '/')}
      onUpdate={() => window.scrollTo(0, 0)}
      history={history}
    >
      <React.Fragment>
        <Layout />

        <style jsx global>{`
          /*****************************************************************************************
          General
          *****************************************************************************************/
          html,
          body,
          #app {
            background-color: ${styles.darkGrey};
            font-family: ${styles.fontStack};
            font-size: ${styles.defaultFontSize};
            height: 100%;
          }

          #app {
            display: flex;
            flex-direction: column;
          }

          #layout-container {
            flex: 1;
          }

          #role-selection-grid,
          #self-rating-track-type-selection-grid,
          #self-rating-selection-grid,
          #rating-selection-grid {
            display: flex;
            align-items: center;
            height: 100%;
          }

          #role-selection-row {
            flex: 1;
          }

          h1 {
            font-size: 36px;
            color: ${styles.offwhite};
          }

          h3 {
            font-size: 24px;
            color: ${styles.offwhite};
          }

          h4 {
            text-transform: uppercase;
            border-bottom: 1px solid ${styles.offwhite};
            padding-bottom: 4px;
            margin-bottom: 10px;
            color: ${styles.offwhite};
            font-size: 22px;
          }

          h6 {
            color: ${styles.offwhite};
            font-size: 14px;

            small {
              font-size: 12px;
              font-style: italic;
            }
          }

          select {
            -moz-appearance: none;
            -webkit-appearance: none;

            &::-ms-expand {
              display: none;
            }
          }

          .dropdown-arrow {
            position: absolute;
            right: 12px;
            top: 12px;
            pointer-events: none;
          }

          .select-feedback {
            right:32px;
          }

          .rating-select-feedback,
          .textarea-feedback {
            display:none;
          }

          ::-webkit-scrollbar {
            width: 12px;
          }

          ::-webkit-scrollbar-track {
            background-color: ${styles.darkerGrey} !important;
          }

          ::-webkit-scrollbar-thumb {
            border-radius: ${styles.defaultBorderRadius};
            box-shadow:none;
            background: ${styles.grey} !important;
          }

          .space-between {
            display: flex;
            justify-content: space-between;
          }

          .no-margin {
            margin: 0;
          }

          .no-padding-left {
            padding-left: 0;
          }

          .no-padding-right {
            padding-right: 0;
          }

          .subtext {
            color: ${styles.lighterGrey};
            font-size: 12px;
          }

          .space-between h6 {
            width: 75%;
          }


          /*****************************************************************************************
          Navbar
          *****************************************************************************************/
          .navbar-toggle {
            margin-top: 25px;
          }

          .notification-title {
            text-transform: none;
            border: none;
          }


          /*****************************************************************************************
          Buttons
          *****************************************************************************************/
          .btn-default {
            background-color: ${styles.lightGrey};
            border: none;
            border-radius: 0px;
            padding: 10px;
            margin: 5px;
            color: ${styles.offwhite};
            transition: ${styles.transition};

            &:hover[disabled] {
              background-color: ${styles.lightGrey};
            }
          }

          /* not nested because Edge and IE11 don't apply the styles when nested */
          .btn-default:hover {
            background-color: ${styles.grey};
            color: ${styles.offwhite};
            transition: ${styles.transition};
            border: none;
            outline: none;
          }

          /* not nested because Edge and IE11 don't apply the styles when nested */
          .btn-default:hover:focus {
            background-color: ${styles.grey};
            color: ${styles.offwhite};
            transition: ${styles.transition};
            border: none;
            outline: none;
          }

          /* not nested because Edge and IE11 don't apply the styles when nested */
          .btn-default:active:focus {
            background-color: ${styles.lightGrey};
            color: ${styles.offwhite};
            transition: ${styles.transition};
            border: none;
            outline: none;
          }

          /* not nested because Edge and IE11 don't apply the styles when nested */
          .btn-default:focus {
            background-color: ${styles.lightGrey};
            color: ${styles.offwhite};
            transition: ${styles.transition};
            border: none;
            outline: none;
          }

          /* not nested because Edge and IE11 don't apply the styles when nested */
          .btn-default:focus-within {
            background-color: ${styles.lightGrey};
            color: ${styles.offwhite};
            transition: ${styles.transition};
            border: none;
            outline: none;
          }

          .btn-danger {
            border: none;
            border-radius: 0px;
            padding: 10px;

            &:hover,
            &:active,
            &:active:focus,
            &:focus,
            &:focus-within {
              border: none;
              outline: none;
            }
          }


          /*****************************************************************************************
          Role Selection
          *****************************************************************************************/
          .role-button.btn-default {
            margin: 12px 0px;
            height: 160px;
            font-size: 30px;
            padding: 0px;
          }

          .role-title {
            padding: 0;
            font-size: 28px;
            color: ${styles.offwhite};
            border-bottom: 1px solid ${styles.lighterGrey};
          }

          .form-title-span {
            color: ${styles.offwhite};
            font-size: 24px;
          }


          /*****************************************************************************************
          Form
          *****************************************************************************************/
          .form-control {
            &:focus {
              outline: none;
              border-color: ${styles.lighterGrey};
              box-shadow: none;
            }
          }

          input.form-control {
            border: none;
            border-bottom: 1px solid ${styles.lighterGrey};
            padding-left: 0px;

            &:focus,
            &:active:focus,
            &:active {
              outline: none;
              box-shadow: none;
            }
          }

          .form-control,
          textarea {
            background: transparent;
            border-radius: 0px;
            color: ${styles.lighterGrey};
            border: 1px solid ${styles.lighterGrey};
          }

          input {
            transition: ${styles.transition};
          }

          textarea {
            width: 100%;
            min-height: 36px;
            resize: none;
            transition: ${styles.transition};
            padding: 7px;

            &::placeholder {
              color: ${styles.lighterGrey};
            }

            &:focus {
              transition: ${styles.transition};
              outline: none;
            }
          }

          .has-success {
            .form-control {
              border: none;
              border-bottom: 1px solid ${styles.green};
              box-shadow: none;
              color: ${styles.green};

              &:focus {
                border: none;
                border-bottom: 1px solid ${styles.darkGreen};
                box-shadow: none;
              }
            }

            select.form-control:focus {
              border: none;
              box-shadow: none;
            }

            textarea {
              border: 1px solid ${styles.green};
              color: ${styles.green};

              &:focus {
                outline: none;
                border: 1px solid ${styles.darkGreen};
              }
            }
          }

          .has-error {
            .form-control {
              border: none;
              border-bottom: 1px solid ${styles.red};
              box-shadow: none;
              color: ${styles.red};

              &:focus {
                border: none;
                border-bottom: 1px solid ${styles.darkRed};
                box-shadow: none;
              }
            }

            select.form-control:focus {
              border: none;
              box-shadow: none;
            }

            textarea {
              border: 1px solid ${styles.red};
              color: ${styles.red};

              &:focus {
                outline: none;
                border: 1px solid ${styles.darkRed};
              }
            }
          }

          .dropdownSelect  {
            border: 1px solid ${styles.lighterGrey};
            max-height: 36px;

            &.rating .glyphicon {
              // display: none;
            }

            &.has-success {
              border: 1px solid ${styles.green};
            }

            .comboBoxControl,
            .stateComboBoxControl {
              border: none;
              outline: none;
              outline: 0;
              box-shadow: none;
              padding: '8px 35px 10px 15px';
            }

            .glyphicon-ok {
              // margin-right: 0px;
            }
          }

          .react-date-picker {
            width: 100%;
            margin-top: 6px;

            .react-date-picker__wrapper {
              border: none !important;
              border-bottom: 1px solid grey !important;

              .react-date-picker__inputGroup {
                color: #ddd;
              }
            }

            .react-date-picker__button__input__input:invalid {
              background-color: transparent;
            }

            .react-date-picker__button {
              width: 60px;
              border: none;
              border-bottom: none;

              input,
              .react-date-picker__button__input__divider {
                color: ${styles.lighterGrey};
              }

              .react-date-picker__button__icon {
                margin-right: 30px;
                outline: none;

                rect, line {
                  stroke: ${styles.lighterGrey};
                }
              }
            }

            .react-date-picker__calendar {
              width: 100%;
              z-index: 3;

              .react-calendar {
                width: 100%;
                background: #000;
                border: none;
                color: ${styles.lighterGrey};
              }

              .react-calendar__navigation {
                background: #000;
                button {
                  &:hover,
                  &:focus,
                  &[disabled] {
                    background-color: #000;
                  }

                  &:hover {
                    color: red;
                  }
                }
              }

              .react-calendar__tile {
                color: ${styles.lighterGrey};

                &:hover {
                  color: ${styles.white};
                  background: ${styles.trdRed};
                  opacity: .5;
                }
            }

              .react-calendar__tile--hasActive,
              .react-calendar__tile--active,
              .react-calendar__tile--active:hover, {
                color: ${styles.white};
                background: ${styles.trdRed};
              }
            }
          }

          .react-daterange-picker {
            width: 100%;
            margin-top: 6px;
            border-bottom: 1px solid ${styles.lighterGrey};

            .react-daterange-picker__button__input__input:invalid {
              background-color: transparent;
            }

            .react-daterange-picker__wrapper {
              width: 100%;
              border: none;
              justify-content: space-between;
              color: rgb(153, 153, 153);
              padding-bottom: 2px;

              input,
              .react-daterange-picker__button__input__divider {
                color: ${styles.lighterGrey};
              }

              .react-daterange-picker__inputGroup {
                max-width: 80px;
              }

              .react-daterange-picker__range-divider {
                margin-top: 4px;
              }

              .react-daterange-picker__calendar-button {
                outline: none;
              }

              .react-daterange-picker__button__icon {
                margin-right: 30px;

                rect, line {
                  stroke: ${styles.lighterGrey};
                }
              }
            }

            .react-daterange-picker__calendar {
              width: 100%;
              z-index: 3;

              .react-calendar {
                width: 100%;
                background: #000;
                border: none;
                color: ${styles.lighterGrey};
              }

              .react-calendar__navigation {
                background: #000;
                button {
                  &:hover,
                  &:focus,
                  &[disabled] {
                    background-color: #000;
                  }

                  &:hover {
                    color: red;
                  }
                }
              }

              abbr {
                border-bottom: none;
                cursor: unset;
                text-decoration: unset;
              }

              .react-calendar__tile {
                color: ${styles.lighterGrey};

                &:hover {
                  color: ${styles.white};
                  background: ${styles.trdRed};
                  opacity: .5;
                }

                &:focus {
                  color: ${styles.white};
                  background: ${styles.trdRed};
                }
              }

              .react-calendar__tile--hover {
                color: ${styles.lighterGrey};
                background: ${styles.darkGrey};

                &:hover {
                  color: ${styles.white};
                  background: ${styles.trdRed};
                  opacity: .5;
                }
              }

              .react-calendar__tile--hasActive,
              .react-calendar__tile--active,
              .react-calendar__tile--active:hover, {
                color: ${styles.white};
                background: ${styles.trdRed};
              }
            }
          }

          /*****************************************************************************************
          Partner & News
          *****************************************************************************************/
          .logo-card {
            text-align: center;
            margin: 25px 10px;
            padding: 20px 50px;
            background-color: ${styles.lightGrey};

            .logo-img {
              padding-top: 10px;
              width: 100%;
              height: 175px;
              background-position: center;
              background-size: contain;
              background-repeat: no-repeat;
            }

            .logo-links {
              margin-top: 1em;

              a {
                color: #fff;
                font-size: 2em;
                margin: .5em;
              }
            }
          }


          /*****************************************************************************************
          Modal
          *****************************************************************************************/
          .modal-dialog {
            .modal-header {
              background-color: ${styles.darkGrey};
              border: none;

              .modal-title {
                border: none;
              }

              .close {
                color: ${styles.offwhite};
                text-shadow: none;
              }
            }

            .modal-body {
              color: ${styles.offwhite};
              background-color: ${styles.darkerGrey};

              .list-group .list-group-item {
                background-color: ${styles.darkestGrey};
                border: none;
                border-bottom: 1px solid ${styles.darkerGrey};
                margin-bottom: 0px;
                color: ${styles.offwhite};

                &:last-child {
                  border: none;
                }
              }
            }

            .modal-footer {
              border: none;
              background-color: ${styles.darkerGrey};
            }
          }

          /*****************************************************************************************
          Mobile
          *****************************************************************************************/
          @media(max-width: 992px) {
            .no-padding-left {
              padding-right: 0px;
            }

            .no-padding-right {
              padding-left: 0px;
            }

            input[type="date"] {
              &::-webkit-clear-button {
                display: none;
              }

              &::-webkit-calendar-picker-indicator {
                background-color: transparent;
              }
            }
          }
        `}</style>
      </React.Fragment>
    </Router>
  </Provider>,
  document.getElementById('app'),
);

if (module.hot) module.hot.accept();
